import styled from 'styled-components'
import QRCode from 'react-qr-code'
import { useTranslation } from 'react-i18next'
import { MemoInfo } from './DepositInfo.memo'
import { Container, QRContainer, AddressLabel, AddressText, CopyButton } from './DepositInfo.styled'
import { DepositViewComponentDepositAddressQuery$data } from '@src/components/wallet/__generated__/DepositViewComponentDepositAddressQuery.graphql'

interface DepositAddressProps {
  address: string
  paymentOrder?: { address: string; memo: string | null }
  depositAddressData?: DepositViewComponentDepositAddressQuery$data | undefined
}

export const DepositAddress = ({ address, paymentOrder, depositAddressData }: DepositAddressProps) => {
  const { t } = useTranslation()

  const onCopy = (event) => {
    if (depositAddressData) navigator.clipboard.writeText(depositAddressData.lastDepositAddress!.address)
    event.target.innerHTML = t('wallet.depositView.copied', 'Copied')
    event.target.classList.add('sent')
  }

  return (
    <Container>
      <QRContainer>
        <QRCode size={122} value={address} />
      </QRContainer>

      {paymentOrder?.address && paymentOrder.memo && <MemoInfo memo={paymentOrder.memo} />}

      <AddressLabel>{t('wallet.depositView.depositAddress', 'Deposit Address')}</AddressLabel>
      <AddressText>{address}</AddressText>
      <CopyButton type="button" onClick={onCopy}>
        {t('wallet.depositView.copy', 'Copy')}
      </CopyButton>
    </Container>
  )
}
